import React from "react";
import Popup from "../../Popup/Popup";
import Types from "./Types";

const TypesPopup = ({
  closeTypesModal,
  onSelectType,
  useTableInAuditTrail = false,
  auditTrailRow,
}) => {
  return (
    <>
      <Popup title={"Type Table"} closeModal={closeTypesModal}>
        <Types
          onSelectType={onSelectType}
          useTableInAuditTrail={useTableInAuditTrail}
          auditTrailRow={auditTrailRow}
        />
      </Popup>
    </>
  );
};

export default TypesPopup;
